module.exports = __webpack_public_path__ + "img/lower flounce length.f3477237.png";